module.exports = __webpack_public_path__ + "assets/adpoly-facility-parking-areas-bulk-upload-template.9531f48f.xlsx";